import type { OrderInquiryWritableState } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { orderInquiryWritePath } from '@/shared/config';
import { buttonVariants, cn } from '@/shared/ui';

interface OrderInquiryWritableNoticeProps {
  readonly orderId: string;
  readonly writable: OrderInquiryWritableState;
}

/** 접수 가능 상태별 한 줄 — 가능하면 접수 화면 링크, 제작 착수 전·처리 중이면 이유 안내, 접수할 수 없는 주문이면 아무것도 없다. */
export const OrderInquiryWritableNotice = ({
  orderId,
  writable,
}: OrderInquiryWritableNoticeProps): ReactElement | null => {
  if (writable === 'WRITABLE') {
    return (
      <Link
        to={orderInquiryWritePath(orderId)}
        className={cn(
          buttonVariants({ variant: 'outline' }),
          'h-12 w-fit min-w-28 border-foreground/20 text-sm',
        )}
      >
        교환·환불 문의
      </Link>
    );
  }
  if (writable === 'NOT_STARTED') {
    return (
      <p className="text-sm text-muted-foreground">제작 착수 전에는 [취소 요청]을 이용해 주세요.</p>
    );
  }
  if (writable === 'ALREADY_OPEN') {
    return (
      <p className="text-sm text-muted-foreground">
        처리 중인 문의가 있어요. 답변 뒤에 다시 접수할 수 있어요.
      </p>
    );
  }
  return null;
};
